// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1VPXH","filesListContainer":"PosDisputesFiles_filesListContainer__2i6_Q","filesButton":"PosDisputesFiles_filesButton__1ThwE"};